import React, { FC, useCallback } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';
import TouchableElement from '@components/common/touchableElement';
import { navigateTo, navigationRef } from '@helpers';
import { useNavigationCheck } from '@v2/pages/machines/hooks/useNavigationCheck';
import { BOTTOM_SHEET_ENABLED, FullNCFileViewDetailsScreenName } from '@v2/pages/common/constants/base.constants';
import { ShowFullNcFileButtonProps } from './types';

const ShowFullNcFileButton: FC<ShowFullNcFileButtonProps> = ({ C, ncFileId, ncFileName, onPress }) => {
  const { safeIsDetailsScreen } = useNavigationCheck();

  const handlePress = useCallback(() => {
    onPress?.();
    if (safeIsDetailsScreen && BOTTOM_SHEET_ENABLED) {
      navigationRef?.current?.navigate(FullNCFileViewDetailsScreenName, { ncFileId, ncFileName });
    } else {
      navigateTo('NCFile', { ncFileId, ncFileName });
    }
  }, [ncFileId, ncFileName, onPress, safeIsDetailsScreen]);

  return (
    <TouchableElement onPress={handlePress}>
      {({ boxStyle }) => (
        <View
          style={[
            boxStyle,
            getBoxShadowStyle({ type: 'Field', C }),
            {
              backgroundColor: C('Label/Light/Inverted'),
              paddingHorizontal: scale(16),
              paddingVertical: scale(8),
              borderRadius: scale(16),
            },
          ]}
        >
          <Text style={[font['Button 3'], { color: C('Label/Light/Primary') }]}>{i18n.t('Show full NC File')}</Text>
        </View>
      )}
    </TouchableElement>
  );
};

export { ShowFullNcFileButton };
